import * as React from 'react';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useEffect } from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { useSnackbar, withSnackbar } from 'notistack';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import logo from '../../assets/img/logo_vertical.png';
import Box from 'elements/Box';
import { ProjectConfig } from 'Global';

const cookies = new Cookies();

interface Lang {
  lang_id: string;
  lang: string;
}

export default withSnackbar(
  function SignIn(props: any) {
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [langs, setLangs] = React.useState<Lang[]>([]);
    const [selectedLang, setSelectedLang] = React.useState<string>(
      localStorage.getItem('lang_id') || '1'
    );

    useEffect(() => {
      props.setLoading(false);

      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: 'lang_list',
          },
        })
        .then((response) => {
          setLangs(response.data.lang_list || []);
        })
        .catch((error) => {
          console.error('Error loading languages:', error);
        });
    }, [props]);

    const tokenApp = localStorage.getItem('tokenApp') || '';

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      const data = new FormData(event.currentTarget);
      setLoading(true);

      axios
        .post(
          ProjectConfig.api_url,
          {
            request: 'sign_in',
            email: data.get('email'),
            password: data.get('password'),
            tokenApp,
          }
        )
        .then((response) => {
          if (response.data.status === 'success') {
            enqueueSnackbar(response.data.message, {
              variant: 'success',
            });

            const userData = response.data.user_data;

            cookies.set('ltkn', userData.ltkn, {
              path: '/',
              maxAge: 86400 * 365,
            });

            cookies.set('user_id', userData.user_id, {
              path: '/',
              maxAge: 86400 * 365,
            });

            cookies.set('user_name', userData.user_name, {
              path: '/',
              maxAge: 86400 * 365,
            });

            cookies.set('role_id', userData.role_id, {
              path: '/',
              maxAge: 86400 * 365,
            });

            localStorage.setItem('user_id', userData.user_id);
            localStorage.setItem('user_name', userData.user_name);
            localStorage.setItem('user_image', userData.image || '');
            localStorage.setItem('role_id', userData.role_id);
            localStorage.setItem('lang_id', selectedLang);
            localStorage.setItem(
              'timezone',
              userData.timezone || 'America/Bogota'
            );

            window.location.reload();
            return;
          }

          enqueueSnackbar(
            response.data.message || 'Usuario o contraseña incorrectos',
            {
              variant: 'error',
            }
          );
        })
        .catch((error) => {
          console.error('Login error:', error);

          enqueueSnackbar(
            'No fue posible iniciar sesión. Inténtalo nuevamente.',
            {
              variant: 'error',
            }
          );
        })
        .finally(() => {
          setLoading(false);
        });
    };

    return (
      <div className="loginContainer">
        <Box id="loginBox">
          <img
            className="loginLogo"
            src={logo}
            alt="Desideria"
          />

          <p style={{ minWidth: '300px' }}>
            Inicia sesión en el sistema
          </p>

          <form
            onSubmit={handleSubmit}
            className="form"
          >
            <FormControl fullWidth>
              <InputLabel id="lang-label">
                Idioma
              </InputLabel>

              <Select
                labelId="lang-label"
                id="lang"
                value={selectedLang}
                label="Idioma"
                onChange={(event) =>
                  setSelectedLang(event.target.value)
                }
                sx={{
                  textTransform: 'capitalize',
                }}
              >
                {langs.map((lang) => (
                  <MenuItem
                    key={lang.lang_id}
                    value={lang.lang_id}
                  >
                    {lang.lang}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              required
              fullWidth
              id="email"
              label="Correo"
              name="email"
              type="text"
              autoComplete="email"
              autoFocus
            />

            <TextField
              required
              fullWidth
              id="password"
              label="Contraseña"
              name="password"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword
                          ? 'Ocultar contraseña'
                          : 'Mostrar contraseña'
                      }
                      onClick={() => setShowPassword((current) => !current)}
                      onMouseDown={(event) => event.preventDefault()}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <LoadingButton
              size="small"
              type="submit"
              loading={loading}
              fullWidth
              variant="contained"
              sx={{
                fontSize: '13px',
                padding: '10px 0',
              }}
            >
              Iniciar sesión
            </LoadingButton>

            <Link
              href="#"
              variant="body2"
            >
              Olvidé mi clave
            </Link>
          </form>
        </Box>
      </div>
    );
  }
);
